import { render, staticRenderFns } from "./insuranceWithdraw.vue?vue&type=template&id=eb6a82c4&scoped=true"
import script from "./insuranceWithdraw.vue?vue&type=script&lang=js"
export * from "./insuranceWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6a82c4",
  null
  
)

export default component.exports